import axios from "../../axiosConfig/axios";

export default {
    UserLogin(data){
        // console.log(`data in login Api ${data.email} & ${data.password}`)
        return axios.post(`user/auth`,
        data,
        {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    forgetPassword(email){
        console.log(email)
        return axios.post('users/auth/password/reset',{
            email:email
        },
        {
            headers:{
                'Content-Type': 'application/json',
            }
        }
        )
    }
};
